import React from "react";
import { Container, Row, Col, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/about/RTI.webp";

const RTIPage = () => {
  return (
    <React.Fragment>
      <title>Right to Information (RTI) | ISBM University</title>
      <meta
        name="description"
        content="Learn about ISBM University’s RTI policies, ensuring transparency, accountability, and access to essential public information and governance details."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Right to Information</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  RTI
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="rti-intro-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <i
                className="ti ti-file-info text-blue mb-4"
                style={{ fontSize: "3rem" }}
              ></i>
              <h2 className="section-title modern-title text-blue">
                RTI Act 2005 Compliance
              </h2>
              <p className="modern-subtitle text-blue">
                Details of PIO and Appellate Authority of ISBM University Under
                RTI Act 2005.
              </p>
              <p>
                ISBM University also aligns with the Right to Information (RTI)
                Act, reinforcing our commitment to transparency and
                accountability. We empower students, parents, and stakeholders
                to seek relevant institutional information as permitted by law.
                This approach not only builds trust but also reflects our
                openness in delivering a student-first experience driven by
                honesty, clarity, and continuous improvement.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Officers Section */}
      <section className="rti-officers-section py-5 bg-light">
        <Container>
          <Row className="g-4 justify-content-center">
            {/* PIO Card */}
            <Col lg={6}>
              <Card className="border-0 shadow h-100">
                <Card.Body className="p-4 p-lg-5">
                  <div className="mb-4">
                    <i
                      className="ti ti-user-check text-purple"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <Card.Title className=" text-blue mb-4">
                    Public Information Officer (PIO)
                  </Card.Title>
                  <div className="rti-officer-details">
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-id me-2 text-blue"></i>Name:
                      </h5>
                      <p className="detail-value">Mr. Diamond Sahu</p>
                    </div>
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-briefcase me-2 text-blue"></i>
                        Designation:
                      </h5>
                      <p className="detail-value">
                        Asst. Prof. School of Arts & Humanities
                      </p>
                    </div>
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-map-pin me-2 text-blue"></i>Address:
                      </h5>
                      <p className="detail-value">
                        ISBM University, Nawapara (Kosmi)
                        <br />
                        Block & Tehsil – Chhura
                        <br />
                        District – Gariyaband
                        <br />
                        Chhattisgarh – 493996
                      </p>
                    </div>
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-mail me-2 text-blue"></i>Email:
                      </h5>
                      <p className="detail-value">
                        <a
                          href="mailto:diamondkumar.sahu@isbmuniversity.edu.in"
                          className="text-blue text-decoration-underline"
                        >
                          diamondkumar.sahu@isbmuniversity.edu.in
                        </a>
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Appellate Authority Card */}
            <Col lg={6}>
              <Card className="border-0 shadow h-100">
                <Card.Body className="p-4 p-lg-5">
                  <div className="mb-4">
                    <i
                      className="ti ti-user-shield text-purple"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <Card.Title className="text-blue mb-4">
                    First Appellate Authority
                  </Card.Title>
                  <div className="rti-officer-details">
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-id me-2 text-blue"></i>Name:
                      </h5>
                      <p className="detail-value">Dr. Barada Prasad Bhol</p>
                    </div>
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-briefcase me-2 text-blue"></i>
                        Designation:
                      </h5>
                      <p className="detail-value">
                        Registrar & First Appellate Authority
                      </p>
                    </div>
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-map-pin me-2 text-blue"></i>Address:
                      </h5>
                      <p className="detail-value">
                        ISBM University, Nawapara (Kosmi)
                        <br />
                        Block & Tehsil – Chhura
                        <br />
                        District – Gariyaband
                        <br />
                        Chhattisgarh – 493996
                      </p>
                    </div>
                    <div className="detail-item">
                      <h5 className="detail-label">
                        <i className="ti ti-mail me-2 text-blue"></i>Email:
                      </h5>
                      <p className="detail-value">
                        <a
                          href="mailto:b.bhol@isbmuniversity.edu.in"
                          className="text-blue text-decoration-underline"
                        >
                          b.bhol@isbmuniversity.edu.in
                        </a>
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default RTIPage;
